
import { Component, Vue, Prop } from "vue-property-decorator";
import store from "../../core/store";
import { ShopService } from "../../core/services/shopService";
import { Format } from "@shared/core/helpers/formatHelper";

@Component
export default class VoucherCard extends Vue {
  @Prop({ required: true, type: Object }) product!: any;
  @Prop({ required: false, type: String }) url!: string;
  @Prop({ required: true, type: Number }) index!: any;
  private images: any[] = [];


  mounted(){
    this.setDefaultImages();
  }

  private setDefaultImages() {
    const context = require.context(
      "@/images/vouchers",
      false,
      /\.(png|jpe?g|webp|gif)$/
    );
    this.images = context.keys().map(context);
  }

  getImageProduct(name: string) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return this.images[this.index % this.images.length];
  }

  formatCurrency(pr: any) {
    var p = store.state.settings.PriceWithTaxes ? pr.grossPrice : pr.netPrice;
    return Format.formatCurrency(p);
  }

  addToCart(p: any, e: any) {
    e.preventDefault();
    new ShopService().addProductToCart(p, 1, e.currentTarget);
  }
  buildUrlShop(product) {
    return `/shop/${product.id}`;
  }
}
